import Vue from "vue";
import Router from "vue-router";
import group_buy from "./router/group_buy";
import sharehotel_router from "./router/sharehotel_router";
import third_route from "./router/third_route";
import group_rob from "./router/group_rob";
import new_oil_card from "./router/new_oil_card";
import lifecircle from "./router/lifecircle";
import car_rent from "./router/car_rent";
import lucky from "./router/lucky";
Vue.use(Router);

const routes = [
  {
    path: "/playcoin",
    component: () => import("./pages/playCoin"),
    meta: {
      title: "玩转积分",
    },
  },
  {
    path: "/load",
    component: () => import("./pages/register/share"),
    meta: {
      title: "去下载",
    },
  },
  {
    path: "/share",
    component: () => import("./pages/register/register"),
    meta: {
      title: "用户注册",
    },
  },
  {
    path: "/shareApplet",
    component: () => import("./pages/register/register"),
    meta: {
      title: "用户注册",
    },
  },
  {
    path: "/commonShare",
    component: () => import("./pages/register/commonShare"),
    meta: {
      title: "我的会员",
    },
  },
  {
    path: "/downLoad",
    component: () => import("./pages/register/downLoad"),
    meta: {
      title: "销巴商家下载须知",
    },
  },
  {
    path: "/goods/detail",
    component: () => import("./pages/shop/detail"),
    meta: {
      title: "商品详情",
    },
  },
  {
    path: "/goods/refundInstructions",
    component: () => import("./pages/shop/refundInstructions"),
    meta: {
      title: "订单退款说明",
    },
  },
  {
    path: "/myInvest",
    component: () => import("./pages/myInvest/index"),
    meta: {
      title: "众筹项目",
    },
  },
  {
    path: "/myInvest/detail",
    component: () => import("./pages/myInvest/detail"),
    meta: {
      title: "众筹详情",
    },
  },
  {
    path: "/myInvest/addIn",
    component: () => import("./pages/myInvest/addIn"),
    meta: {
      title: "我要参与",
    },
  },
  {
    path: "/myInvest/confirm",
    component: () => import("./pages/myInvest/confirm"),
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/myInvest/full",
    component: () => import("./pages/myInvest/full"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/myInvest/order",
    component: () => import("./pages/myInvest/order"),
    meta: {
      title: "订单列表",
    },
  },
  {
    path: "/myInvest/order/list",
    component: () => import("./pages/myInvest/orderList"),
    meta: {
      title: "众筹列表",
    },
  },
  {
    path: "/myInvest/income",
    component: () => import("./pages/myInvest/income"),
    meta: {
      title: "我的收益",
    },
  },
  {
    path: "/myInvest/earning",
    component: () => import("./pages/myInvest/earning"),
    meta: {
      title: "收益详情",
    },
  },
  {
    path: "/myInvest/earning_order",
    component: () => import("./pages/myInvest/earning_order"),
    meta: {
      title: "收益详情",
    },
  },
  {
    path: "/myInvest/selectRefund",
    component: () => import("./pages/myInvest/selectRefund"),
    meta: {
      title: "选择退股订单",
    },
  },
  {
    path: "/myInvest/application",
    component: () => import("./pages/myInvest/application"),
    meta: {
      title: "申请退股",
    },
  },
  {
    path: "/myInvest/points",
    component: () => import("./pages/myInvest/points"),
    meta: {
      title: "积分中心",
    },
  },
  {
    path: "/myInvest/coins",
    component: () => import("./pages/myInvest/coins"),
    meta: {
      title: "红包中心",
    },
  },
  {
    path: "/aggrement",
    component: () => import("./pages/aggrement/index"),
    meta: {
      title: "协议",
    },
  },
  {
    path: "/message",
    component: () => import("./pages/member/message"),
    meta: {
      title: "系统消息",
    },
  },
  {
    path: "/message/detail",
    component: () => import("./pages/member/detail"),
    meta: {
      title: "消息详情",
    },
  },
  {
    path: "/notice",
    component: () => import("./pages/member/notice"),
    meta: {
      title: "公告消息",
    },
  },
  {
    path: "/notice/detail",
    component: () => import("./pages/member/noticeDetail"),
    meta: {
      title: "公告详情",
    },
  },
  {
    path: "/activity",
    component: () => import("./pages/member/activity"),
    meta: {
      title: "销巴活动",
    },
  },
  {
    path: "/activity/detail",
    component: () => import("./pages/member/activityDetail"),
    meta: {
      title: "活动详情",
    },
  },
  {
    path: "/talentCode",
    component: () => import("./pages/member/talentCode.vue"),
    meta: {
      title: "销巴达人",
    },
  },
  {
    path: "/talentGoods",
    component: () => import("./pages/member/talentGoods.vue"),
    meta: {
      title: "选择积分支付",
    },
  },
  {
    path: "/ultraCode",
    component: () => import("./pages/member/ultraCode.vue"),
    meta: {
      title: "微超经理人",
    },
  },
  {
    path: "/ultraGoods",
    component: () => import("./pages/member/ultraGoods.vue"),
    meta: {
      title: "选择商品支付",
    },
  },
  {
    path: "/electric/shop",
    component: () => import("./pages/selfSupport/electric"),
    meta: {
      title: "销巴电器",
    },
  },
  {
    path: "/supermarket",
    component: () => import("./pages/selfSupport/supermarket"),
    meta: {
      title: "销巴超市",
    },
  },
  {
    path: "/causesuper",
    component: () => import("./pages/selfSupport/causesuper"),
    meta: {
      title: "超市模板",
    },
  },
  {
    path: "/causelectric",
    component: () => import("./pages/selfSupport/causelectric"),
    meta: {
      title: "电器模板",
    },
  },
  {
    path: "/plane/problem",
    component: () => import("./pages/plane/commonProblem"),
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/problem/answer",
    component: () => import("./pages/plane/answer"),
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/plane/index",
    component: () => import("./pages/plane/index"),
    meta: {
      title: "机票出行",
    },
  },
  {
    path: "/plane/calendar",
    component: () => import("./pages/plane/calendar/index"),
    meta: {
      title: "选择日期",
    },
  },
  {
    path: "/choose/passenger",
    component: () => import("./pages/plane/choosePassenger"),
    meta: {
      title: "选择乘机人",
    },
  },
  {
    path: "/add/passenger",
    component: () => import("./pages/plane/addPassenger"),
    meta: {
      title: "添加旅客信息",
    },
  },
  {
    path: "/plane/detail",
    component: () => import("./pages/plane/detail"),
    meta: {
      title: "机票详情",
    },
  },
  {
    path: "/select/list",
    component: () => import("./pages/plane/selectList"),
    meta: {
      title: "搜索结果",
    },
  },
  {
    path: "/collection/list",
    component: () => import("./pages/plane/collectionList"),
    meta: {
      title: "收藏航班",
    },
  },
  {
    path: "/submit/order",
    component: () => import("./pages/plane/submitOrder"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/plane/order/list",
    component: () => import("./pages/plane/orderList"),
    meta: {
      title: "订单列表",
    },
  },
  {
    path: "/order/detail",
    component: () => import("./pages/plane/orderDetail"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/help",
    component: () => import("./pages/help/index"),
    meta: {
      title: "在线帮助",
    },
  },
  {
    path: "/second",
    component: () => import("./pages/help/second"),
    meta: {
      title: "在线帮助",
    },
  },
  {
    path: "/answer",
    component: () => import("./pages/help/answer"),
    meta: {
      title: "在线帮助",
    },
  },
  {
    path: "/toshare",
    component: () => import("./pages/toShare/index.vue"),
    meta: {
      title: "分享",
    },
  },
  {
    path: "/qrCode",
    component: () => import("./pages/toShare/qrCode.vue"),
    meta: {
      title: "我的分享码",
    },
  },
  {
    path: "/shareDetail",
    component: () => import("./pages/shop/shareDetail.vue"),
    meta: {
      title: "关闭",
    },
  },
  {
    path: "/car/comparisons",
    component: () => import("./pages/car/comparisons"),
    meta: {
      title: "车型对比",
    },
  },
  {
    path: "/car/aboutUs",
    component: () => import("./pages/car/aboutUs"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/car/detail",
    component: () => import("./pages/car/detail"),
    meta: {
      title: "汽车详情",
    },
  },
  {
    path: "/car/activity",
    component: () => import("./pages/car/activity"),
    meta: {
      title: "汽车专题",
    },
  },
  {
    path: "/member/privilege",
    component: () => import("./pages/member/privilege"),
    meta: {
      title: "会员特权",
    },
  },
  {
    path: "/member/rules",
    component: () => import("./pages/member/rules"),
    meta: {
      title: "规则",
    },
  },
  {
    path: "/rankList",
    component: () => import("./pages/member/rankList"),
    meta: {
      title: "排行榜",
    },
  },
  {
    path: "/identity/authenticate",
    component: () => import("./pages/member/identity/authenticate"),
    meta: {
      title: "身份认证",
    },
  },
  {
    path: "/companyInfo",
    component: () => import("./pages/member/identity/companyInfo"),
    meta: {
      title: "公司信息",
    },
  },
  {
    path: "/authenticate/result",
    component: () => import("./pages/member/identity/result"),
    meta: {
      title: "认证结果",
    },
  },
  {
    path: "/advDetail/applyFor",
    component: () => import("./pages/advDetail/applyFor"),
    meta: {
      title: "申请加盟商",
    },
  },
  {
    path: "/advDetail/market_join",
    component: () => import("./pages/advDetail/market_join"),
    meta: {
      title: "申请加盟商",
    },
  },
  {
    path: "/advDetail/clothes",
    component: () => import("./pages/advDetail/clothes"),
    meta: {
      title: "奢侈品合伙人招募",
    },
  },
  {
    path: "/advDetail/clothesCrocodile",
    component: () => import("./pages/advDetail/clothesCrocodile"),
    meta: {
      title: "销巴服饰X鳄鱼恤",
    },
  },
  {
    path: "/advDetail/brandMonth",
    component: () => import("./pages/advDetail/brandMonth"),
    meta: {
      title: "明星商家成长计划",
    },
  },
  {
    path: "/advDetail/car", //汽车招商
    component: () => import("./pages/advDetail/car"),
    meta: {
      title: "销巴汽车",
    },
  },
  {
    path: "/advDetail/carRetail", //汽车新零售
    component: () => import("./pages/advDetail/carRetail"),
    meta: {
      title: "销巴汽车",
    },
  },
  {
    path: "/advDetail/decorate",
    component: () => import("./pages/advDetail/decorate"),
    meta: {
      title: "销巴装饰全国招商加盟",
    },
  },
  {
    path: "/advDetail/integral",
    component: () => import("./pages/advDetail/integral"),
    meta: {
      title: "积分商城招商啦",
    },
  },
  {
    path: "/advDetail/medical",
    component: () => import("./pages/advDetail/medical"),
    meta: {
      title: "销巴医疗招募",
    },
  },
  {
    path: "/advDetail/commercialAgent",
    component: () => import("./pages/advDetail/commercialAgent"),
    meta: {
      title: "代理商加盟",
    },
  },
  {
    path: "/advDetail/realty",
    component: () => import("./pages/advDetail/realty"),
    meta: {
      title: "招募地产项目",
    },
  },
  {
    path: "/advDetail/microSuper",
    component: () => import("./pages/advDetail/microSuper"),
    meta: {
      title: "智能微超招商",
    },
  },
  {
    path: "/advDetail/question",
    component: () => import("./pages/advDetail/question"),
    meta: {
      title: "问卷调查参与领奖",
    },
  },
  {
    path: "/advDetail/fruits",
    component: () => import("./pages/advDetail/fruits"),
    meta: {
      title: "鲜味立即享",
    },
  },
  {
    path: "/advDetail/haier",
    component: () => import("./pages/advDetail/haier"),
    meta: {
      title: "海尔天天有惊喜",
    },
  },
  {
    path: "/advDetail/carnival",
    component: () => import("./pages/advDetail/carnival"),
    meta: {
      title: "销巴超市狂欢节",
    },
  },
  {
    path: "/advDetail/qixiFestivel",
    component: () => import("./pages/advDetail/qixiFestivel"),
    meta: {
      title: "七夕有奖",
    },
  },
  {
    path: "/advDetail/qixiActivity",
    component: () => import("./pages/advDetail/qixiActivity"),
    meta: {
      title: "爱要有礼才完美",
    },
  },
  {
    path: "/advDetail/house",
    component: () => import("./pages/advDetail/house"),
    meta: {
      title: "销巴地产",
    },
  },
  {
    path: "/advDetail/houseYangtze",
    component: () => import("./pages/advDetail/houseYangtze"),
    meta: {
      title: "销巴地产融创合作项目",
    },
  },
  {
    path: "/advDetail/medicalAesthetics",
    component: () => import("./pages/advDetail/medicalAesthetics"),
    meta: {
      title: "销巴医美",
    },
  },
  {
    path: "/advDetail/fashionClothes",
    component: () => import("./pages/advDetail/fashionClothes"),
    meta: {
      title: "潮流服饰",
    },
  },
  {
    path: "/advDetail/house",
    component: () => import("./pages/advDetail/house"),
    meta: {
      title: "销巴地产",
    },
  },
  {
    path: "/advDetail/sportsCause",
    component: () => import("./pages/advDetail/sportsCause"),
    meta: {
      title: "销巴体育",
    },
  },
  {
    path: "/advDetail/realEstate",
    component: () => import("./pages/advDetail/realEstate"),
    meta: {
      title: "销巴地产顾问招募",
    },
  },
  {
    path: "/advDetail/systemNotification",
    component: () => import("./pages/advDetail/systemNotification"),
    meta: {
      title: "租房系统上线告知",
    },
  },
  {
    path: "/advDetail/commonActivity",
    component: () => import("./pages/advDetail/commonActivity"),
    meta: {
      title: "日常活动",
    },
  },
  {
    path: "/game/threewaylogin",
    component: () => import("./pages/game/three-way-login.vue"),
    meta: {
      title: "三方登录",
    },
  },
  {
    path: "/game/bigTurntable_A",
    component: () => import("./pages/game/bigTurntable_A"),
    meta: {
      title: "大转盘-A",
    },
  },
  {
    path: "/game/bigTurntable_B",
    component: () => import("./pages/game/bigTurntable_B"),
    meta: {
      title: "大转盘-B",
    },
  },
  {
    path: "/game/myProfit",
    component: () => import("./pages/game/myProfit"),
    meta: {
      title: "我的奖品",
    },
  },
  {
    path: "/game/address",
    component: () => import("./pages/game/address"),
    meta: {
      title: "选择收货地址",
    },
  },
  {
    path: "/platform-activity",
    component: () => import("./pages/platform-activity/PlatformActivity.vue"),
    meta: {
      title: "平台活动",
    },
  },
  {
    path: "/advDetail/joinUs",
    component: () => import("./pages/advDetail/joinUs"),
    meta: {
      title: "代理商招募",
    },
  },
  /*平台活动*/
  {
    path: "/takingCar/orderList",
    component: () => import("./pages/takingCar/orderList.vue"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/takingCar/invoice",
    component: () => import("./pages/takingCar/invoice.vue"),
    meta: {
      title: "开具发票",
    },
  },
  // 易道打车
  {
    path: "/takingCar/journeyInvoice",
    component: () => import("./pages/takingCar/journeyInvoice.vue"),
    meta: {
      title: "按行程开票",
    },
  },
  {
    path: "/takingCar/moreMsg",
    component: () => import("./pages/takingCar/moreMsg.vue"),
    meta: {
      title: "更多信息",
    },
  },
  {
    path: "/takingCar/invoiceDetails",
    component: () => import("./pages/takingCar/invoiceDetails.vue"),
    meta: {
      title: "按行程开票详情",
    },
  },
  {
    path: "/takingCar/invoiceHistory",
    component: () => import("./pages/takingCar/invoiceHistory.vue"),
    meta: {
      title: "开具历史",
    },
  },
  {
    path: "/takingCar/historyDetails",
    component: () => import("./pages/takingCar/historyDetails.vue"),
    meta: {
      title: "发票详情",
    },
  },
  {
    path: "/takingCar/journeyInformation",
    component: () => import("./pages/takingCar/journeyInformation.vue"),
    meta: {
      title: "发票行程信息",
    },
  },
  {
    path: "/takingCar/allCarType",
    component: () => import("./pages/takingCar/allCarType.vue"),
    meta: {
      title: "全部车型",
    },
  },
  {
    path: "/takingCar/moneyDetail",
    component: () => import("./pages/takingCar/moneyDetail.vue"),
    meta: {
      title: "预估费用明细",
    },
  },
  {
    path: "/takingCar/selectCar",
    component: () => import("./pages/takingCar/selectCar.vue"),
    meta: {
      title: "车型选择",
    },
  },
  {
    path: "/takingCar/selectScenery",
    component: () => import("./pages/takingCar/selectScenery.vue"),
    meta: {
      title: "机场选择",
    },
  },
  {
    path: "/takingCar/complaint",
    component: () => import("./pages/takingCar/complaint.vue"),
    meta: {
      title: "投诉详情",
    },
  },
  {
    path: "/takingCar/cancelReason",
    component: () => import("./pages/takingCar/cancelReason.vue"),
    meta: {
      title: "选择投诉原因",
    },
  },
  {
    path: "/takingCar/cancelFee",
    component: () => import("./pages/takingCar/cancelFee.vue"),
    meta: {
      title: "有无取消费用",
    },
  },
  {
    path: "/takingCar/cancelRules",
    component: () => import("./pages/takingCar/cancelRules.vue"),
    meta: {
      title: "取消规则",
    },
  },
  {
    path: "/recharge/rechargeHome",
    component: () => import("./pages/recharge/rechargeHome.vue"),
    meta: {
      title: "充值中心",
    },
  },
  {
    path: "/recharge/myOrder",
    component: () => import("./pages/recharge/myOrder.vue"),
    meta: {
      title: "我的订单",
    },
  },
  // 充值
  {
    path: "/recharge/orderDetail",
    component: () => import("./pages/recharge/orderDetail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/recharge/rechargePlatform",
    component: () => import("./pages/recharge/rechargePlatform.vue"),
    meta: {
      title: "平台充值",
    },
  },
  // {
  //     path: '/debtRelief/wrDebtPersonHome1',
  //     component: () => import('./pages/member/pending.vue'),
  //     meta: {
  //         title: '万融解债'
  //     }
  // },
  {
    path: "/debtRelief/wrDebtPersonHome",
    component: () => import("./pages/debtRelief/wrDebtPersonHome.vue"),
    meta: {
      title: "万融解债-个人",
    },
  },
  // {
  //     path: '/debt/authenticate',
  //     component: () => import('./pages/debt/authenticate.vue'),
  //     meta: {
  //         title: '身份认证'
  //     }
  // },

  // {
  //     path: '/debtRelief/wrDebtPersonHome1',
  //     component: () => import('./pages/member/pending.vue'),
  //     meta: {
  //         title: '万融解债'
  //     }
  // },
  {
    path: "/debtRelief/wrDebtPersonHome",
    component: () => import("./pages/debtRelief/wrDebtPersonHome.vue"),
    meta: {
      title: "万融解债-个人",
    },
  },
  // {
  //     path: '/debt/authenticate',
  //     component: () => import('./pages/debt/authenticate.vue'),
  //     meta: {
  //         title: '身份认证'
  //     }
  // },
  {
    path: "/debtor/debtorView",
    component: () => import("./pages/debtRelief/debtor/debtorView"),
    meta: {
      title: "债务人",
    },
  },
  // {
  //     path: '/debtRelief/wrDebtPersonHome1',
  //     component: () => import('./pages/member/pending.vue'),
  //     meta: {
  //         title: '万融解债'
  //     }
  // },
  {
    path: "/debtRelief/solutionDebtInfoDebtor",
    component: () => import("./pages/debtRelief/solutionDebtInfoDebtor"),
    meta: {
      title: "创建订单1",
    },
  },
  // {
  //     path: '/debt/authenticate',
  //     component: () => import('./pages/debt/authenticate.vue'),
  //     meta: {
  //         title: '身份认证'
  //     }
  // },
  {
    path: "/debtRelief/solutionDebtInfoCreditor",
    component: () => import("./pages/debtRelief/solutionDebtInfoCreditor"),
    meta: {
      title: "创建订单2",
    },
  },
  {
    path: "/debtRelief/resultAuthReject",
    component: () => import("./pages/debtRelief/debtor/resultAuthReject"),
    meta: {
      title: "认证驳回",
    },
  },
  {
    path: "/debtRelief/resultCreateDebt",
    component: () => import("./pages/debtRelief/debtor/resultCreateDebt"),
    meta: {
      title: "解债信息",
    },
  },
  {
    path: "/debtor/detail",
    component: () => import("./pages/debtRelief/debtor/debtorDetail"),
    meta: {
      title: "债务详情",
    },
  },
  {
    path: "/debtor/electroniContract",
    component: () => import("./pages/debtRelief/debtor/electroniContract"),
    meta: {
      title: "查看电子合同",
    },
  },
  {
    path: "/creditor/creditorView",
    component: () => import("./pages/debtRelief/creditor/creditorView"),
    meta: {
      title: "债权人",
    },
  },
  {
    path: "/creditor/detail",
    component: () => import("./pages/debtRelief/creditor/creditorDetail"),
    meta: {
      title: "债权详情",
    },
  },

  {
    path: "/creditor/resultSubmitIOU",
    component: () => import("./pages/debtRelief/creditor/resultSubmitIOU"),
    meta: {
      title: "债权人提交结果",
    },
  },
  {
    path: "/creditor/resultSubmitPayVoucher",
    component: () => import("./pages/debtRelief/debtor/resultSubmitPayVoucher"),
    meta: {
      title: "债权人提交结果",
    },
  },
  {
    path: "/agent/agentView",
    component: () => import("./pages/debtRelief/agent/agentView"),
    meta: {
      title: "经纪人",
    },
  },
  {
    path: "/agent/detail",
    component: () => import("./pages/debtRelief/agent/agentDetail"),
    meta: {
      title: "经纪人详情",
    },
  },
  {
    path: "/debtor/my",
    component: () => import("./pages/debtRelief/debtor/my"),
    meta: {
      title: "我的",
    },
  },
  {
    path: "/debtor/signContract",
    component: () => import("./pages/debtRelief/debtor/signContract"),
    meta: {
      title: "签订合同",
    },
  },
  {
    path: "/debtor/signature",
    component: () => import("./pages/debtRelief/debtor/signature"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/debtor_creditor/resultSignature",
    component: () => import("./pages/debtRelief/debtor/resultSignature"),
    meta: {
      title: "签名完成",
    },
  },

  {
    path: "/agent/introduceMyself",
    component: () => import("./pages/debtRelief/agent/introduceMyself"),
    meta: {
      title: "经纪人介绍",
    },
  },
  {
    path: "/agent/resultSignature",
    component: () => import("./pages/debtRelief/agent/resultSignature"),
    meta: {
      title: "签名结果",
    },
  },
  {
    path: "/agent/resultSign2",
    component: () => import("./pages/debtRelief/agent/resultSign2"),
    meta: {
      title: "签名结果",
    },
  },
  {
    path: "/agent/myCommission",
    component: () => import("./pages/debtRelief/agent/myCommission"),
    meta: {
      title: "查看佣金",
    },
  },
  {
    path: "/agent/commissionWithdrawal",
    component: () => import("./pages/debtRelief/agent/commissionWithdrawal"),
    meta: {
      title: "佣金提现",
    },
  },
  {
    path: "/agent/commissionIncludeDetail",
    component: () => import("./pages/debtRelief/agent/commissionIncludeDetail"),
    meta: {
      title: "收入明细",
    },
  },
  {
    path: "/agent/commissionDetail",
    component: () => import("./pages/debtRelief/agent/commissionDetail"),
    meta: {
      title: "佣金提现详情",
    },
  },
  {
    path: "/agent/withdrawalProcess",
    component: () => import("./pages/debtRelief/agent/withdrawalProcess"),
    meta: {
      title: "佣金提现申请结果",
    },
  },
  {
    path: "/agent/checkAgreement",
    component: () => import("./pages/debtRelief/agent/checkAgreement"),
    meta: {
      title: "查看协议",
    },
  },
  {
    path: "/agent/showContract",
    component: () => import("./pages/debtRelief/agent/showContract"),
    meta: {
      title: "经纪人合同",
    },
  },
  // {
  //     path: '/debtRelief/wrDebtPersonHome',
  //     component: () => import('./pages/member/pending.vue'),
  //     meta: {
  //         title: '万融解债'
  //     }
  // },
  // 房产项目（不要删我房产的东西！！！！求你了！ღ( ´･ᴗ･` )）
  {
    path: "/debtRelief/businessDesc",
    component: () => import("./pages/debtRelief/businessDesc.vue"),
    meta: {
      title: "万融解债业务说明",
    },
  },
  {
    path: "/agent/myTeam",
    component: () => import("./pages/debtRelief/agent/myTeam.vue"),
    meta: {
      title: "我的团队",
    },
  },

  // 房产项目(解决冲突不要删我房产的东西，求你了！！！！！！)
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！

    path: "/house/signContract",
    component: () => import("./pages/house/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    path: "/house/signature",
    component: () => import("./pages/house/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/house/Signed",
    component: () => import("./pages/house/Signed.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    path: "/house/waitSigned",
    component: () => import("./pages/house/waitSigned.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！

    path: "/house/person/signContract",
    component: () => import("./pages/house/personSign/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    path: "/house/person/signature",
    component: () => import("./pages/house/personSign/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/house/person/signed",
    component: () => import("./pages/house/personSign/Signed.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/joinStoresSign/signContract",
    component: () => import("./pages/house/joinStoresSign/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/joinStoresSign/signature",
    component: () => import("./pages/house/joinStoresSign/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/house/videoTabPage",
    component: () => import("./pages/house/videoTabPage.vue"),
    meta: {
      title: "视频专区",
      keepAlive: true,
    },
  },
  {
    path: "/house/player",
    component: () => import("./pages/house/player.vue"),
    meta: {
      title: "视频详情",
    },
  },
  // 不要删我房产的东西！！！！求你了！ღ( ´･ᴗ･` )
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/playerShare",
    component: () => import("./pages/house/playerShare.vue"),
    meta: {
      title: "视频详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/houseDetail",
    component: () => import("./pages/house/houseDetail.vue"),
    meta: {
      title: "房源详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/newHouseDetail",
    component: () => import("./pages/house/newHouseDetail.vue"),
    meta: {
      title: "楼盘详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/secondHandHouseDetail",
    component: () => import("./pages/house/secondHandHouseDetail.vue"),
    meta: {
      title: "二手房详情",
    },
  },
  {
    path: "/house/subsidies/signContract",
    component: () => import("./pages/house/subsidies/signContract.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/subsidies/signature",
    component: () => import("./pages/house/subsidies/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  // 解决冲突不要删我房产的东西，求你了！！！！！！
  {
    path: "/house/cms/agreementPage",
    component: () => import("./pages/house/cms/agreementPage.vue"),
    meta: {
      title: "协议",
    },
  },
  //房产物业引导页
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding1",
    component: () => import("./pages/house/property/binding/binding1.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding2",
    component: () => import("./pages/house/property/binding/binding2.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding3",
    component: () => import("./pages/house/property/binding/binding3.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding4",
    component: () => import("./pages/house/property/binding/binding4.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding5",
    component: () => import("./pages/house/property/binding/binding5.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/property/binding6",
    component: () => import("./pages/house/property/binding/binding6.vue"),
    meta: {
      title: "绑定物业",
    },
  },
  //房产物业首页
  {
    path: "/house/property/propertyIndex",
    component: () => import("./pages/house/property/index/propertyIndex.vue"),
    meta: {
      title: "物业首页",
    },
  },
  //房产物业信息
  {
    path: "/house/property/propertyInfo",
    component: () => import("./pages/house/property/index/propertyInfo.vue"),
    meta: {
      title: "物业信息",
    },
  },
  //房产物业缴费
  {
    path: "/house/property/propertyPayCostIndex",
    component: () =>
      import("./pages/house/property/payCost/propertyPayCostIndex.vue"),
    meta: {
      title: "物业缴费",
    },
  },
  //房产物业缴费记录
  {
    path: "/house/property/propertyPayCostRecord",
    component: () => import("./pages/house/property/payCost/record.vue"),
    meta: {
      title: "物业缴费记录",
    },
  },
  //房产物业缴费详情
  {
    path: "/house/property/propertyPayCostDetail",
    component: () => import("./pages/house/property/payCost/detail.vue"),
    meta: {
      title: "物业缴费详情",
    },
  },
  //房产物业支付结果
  {
    path: "/house/property/paySuccess",
    component: () => import("./pages/house/property/payCost/paySuccess.vue"),
    meta: {
      title: "支付结果",
    },
  },
  // 房产物业公告列表
  {
    path: "/house/property/propertyNoticeList",
    component: () => import("./pages/house/property/notice/list.vue"),
    meta: {
      title: "公告列表",
    },
  },
  // 房产物业公告详情
  {
    path: "/house/property/propertyNoticeDetail",
    component: () => import("./pages/house/property/notice/detail.vue"),
    meta: {
      title: "公告详情",
    },
  },
  // 房产物业报修
  {
    path: "/house/property/propertyRepairIndex",
    component: () => import("./pages/house/property/repair/index.vue"),
    meta: {
      title: "物业报修",
    },
  },
  // 房产物业报修记录
  {
    path: "/house/property/propertyRepairRecord",
    component: () => import("./pages/house/property/repair/record.vue"),
    meta: {
      title: "报修记录",
    },
  },
  // 房产物业报修审核
  {
    path: "/house/property/propertyRepairSuccess",
    component: () => import("./pages/house/property/repair/success.vue"),
    meta: {
      title: "提交结果",
    },
  },
  // 房产物业投诉建议
  {
    path: "/house/property/propertyComplaintsIndex",
    component: () => import("./pages/house/property/complaints/index.vue"),
    meta: {
      title: "物业投诉",
    },
  },
  // 房产物业投诉建议记录
  {
    path: "/house/property/propertyComplaintsRecord",
    component: () => import("./pages/house/property/complaints/record.vue"),
    meta: {
      title: "投诉记录",
    },
  },
  // 房产物业投诉建议提交结果
  {
    path: "/house/property/propertyComplaintsSuccess",
    component: () => import("./pages/house/property/complaints/success.vue"),
    meta: {
      title: "提交结果",
    },
  },
  // 房产物业便民电话
  {
    path: "/house/property/propertyConvenientPhone",
    component: () => import("./pages/house/property/convenientPhone/index.vue"),
    meta: {
      title: "便民电话",
    },
  },
  // 房产物业活动列表
  {
    path: "/house/property/propertyActivityList",
    component: () => import("./pages/house/property/activity/list.vue"),
    meta: {
      title: "活动列表",
    },
  },
  // 房产物业活动详情
  {
    path: "/house/property/propertyActivityDetail",
    component: () => import("./pages/house/property/activity/detail.vue"),
    meta: {
      title: "活动详情",
    },
  },
  // 房产物业文章列表
  {
    path: "/house/property/propertyArticleList",
    component: () => import("./pages/house/property/article/list.vue"),
    meta: {
      title: "文章列表",
    },
  },
  // 房产物业文章详情
  {
    path: "/house/property/propertyArticleDetail",
    component: () => import("./pages/house/property/article/detail.vue"),
    meta: {
      title: "文章详情",
    },
  },
  // 加盟门店合同签署
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/joinStoresSign/signContract",
    component: () => import("./pages/house/joinStoresSign/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/joinStoresSign/signature",
    component: () => import("./pages/house/joinStoresSign/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  // 房产任务进度
  {
    path: "/house/missionSchedule",
    component: () => import("./pages/house/missionSchedule.vue"),
    meta: {
      title: "任务进度",
    },
  },
  {
    path: "/debtRelief/businessDesc",
    component: () => import("./pages/debtRelief/businessDesc.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    path: "/agent/myTeam",
    component: () => import("./pages/debtRelief/agent/myTeam.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/agent/perforDetail",
    component: () => import("./pages/debtRelief/agent/perforDetail.vue"),
    meta: {
      title: "团队业绩明细",
    },
  },
  {
    path: "/agent/allowanceDetail",
    component: () => import("./pages/debtRelief/agent/allowanceDetail.vue"),
    meta: {
      title: "团队管理津贴明细",
    },
  },
  {
    path: "/agent/policyInfo",
    component: () => import("./pages/debtRelief/agent/policyInfo.vue"),
    meta: {
      title: "团队政策解读",
    },
  },
  {
    path: "/agent/agentQrcode",
    component: () => import("./pages/debtRelief/agent/agentQrcode.vue"),
    meta: {
      title: "经纪人推广码",
    },
  },
  {
    path: "/agent/contractView",
    component: () => import("./pages/debtRelief/agent/contractView.vue"),
    meta: {
      title: "电子合同",
    },
  },
  //酒店项目
  {
    path: "/hotel/home",
    name: "home",
    component: () => import("./pages/hotel/home/home.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/hotel/advertisement",
    name: "advertisement",
    component: () => import("./pages/hotel/home/advertisement.vue"),
    meta: {
      title: "广告页",
    },
  },
  // {
  //     path: '/debtRelief/wrDebtPersonHome',
  //     component: () => import('./pages/member/pending.vue'),
  //     meta: {
  //         title: '万融解债'
  //     }
  // },
  {
    path: "/hotel/city",
    name: "city",
    component: () => import("./pages/hotel/home/city.vue"),
    meta: {
      title: "城市选择",
    },
  },
  {
    path: "/hotel/search",
    name: "search",
    component: () => import("./pages/hotel/home/search.vue"),
    meta: {
      title: "搜索",
    },
  },
  {
    path: "/hotel/choose",
    name: "choose",
    component: () => import("./pages/hotel/home/choose.vue"),
    meta: {
      title: "筛选",
      keepAlive: true,
    },
  },
  {
    path: "/hotel/collection",
    name: "collection",
    component: () => import("./pages/hotel/collection/collection.vue"),
    meta: {
      title: "收藏",
      keepAlive: true,
    },
  },
  {
    path: "/hotel/myOrder",
    component: () => import("./pages/hotel/order/list.vue"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/hotel/cancelOrder",
    component: () => import("./pages/hotel/order/cancelOrder.vue"),
    meta: {
      title: "选择取消原因",
    },
  },
  {
    path: "/hotel/statusDetail",
    component: () => import("./pages/hotel/order/statusDetail.vue"),
    meta: {
      title: "状态详情",
    },
  },
  {
    path: "/hotel/orderDetail",
    component: () => import("./pages/hotel/order/orderDetail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/hotel/detail",
    component: () => import("./pages/hotel/detail/detail.vue"),
    meta: {
      title: "酒店详情",
      keepAlive: true,
    },
  },
  {
    path: "/hotel/checkin",
    component: () => import("./pages/hotel/detail/checkin.vue"),
    meta: {
      title: "入住信息",
    },
  },
  {
    path: "/hotel/detailinfo",
    component: () => import("./pages/hotel/detail/detailinfo.vue"),
    meta: {
      title: "酒店信息",
    },
  },
  {
    path: "/hotel/qualificationinfo",
    component: () => import("./pages/hotel/detail/qualificationinfo.vue"),
    meta: {
      title: "商家资质",
    },
  },
  {
    path: "/hotel/position",
    component: () => import("./pages/hotel/detail/position.vue"),
    meta: {
      title: "定位",
    },
  },
  {
    path: "/hotel/confirmorder",
    name: "confirmorder",
    component: () => import("./pages/hotel/home/confirmorder"),
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/hotel/paysuccess",
    name: "paysuccess",
    component: () => import("./pages/hotel/home/paysuccess"),
    meta: {
      title: "支付成功",
    },
  },
  {
    path: "/hotel/lookimg",
    component: () => import("./pages/hotel/detail/lookimg.vue"),
    meta: {
      title: "查看图片",
    },
  },
  // 补贴分享详情
  {
    path: "/house/subShare",
    component: () => import("./pages/house/subShare.vue"),
    meta: {
      title: "分享详情",
    },
  },
  {
    path: "/xiaobaGroup/groupCode",
    component: () => import("./pages/xiaobaGroup/groupCode.vue"),
    meta: {
      title: "销巴群主",
    },
  },
  {
    path: "/xiaobaGroup/joinGroup",
    component: () => import("./pages/xiaobaGroup/joinGroup.vue"),
    meta: {
      title: "入群赚取推广奖励",
    },
  },
  {
    path: "/xiaobaGroup/groupRule",
    component: () => import("./pages/xiaobaGroup/groupRule.vue"),
    meta: {
      title: "群政策解读",
    },
  },
  {
    path: "/xiaobaGroup/myGroup",
    component: () => import("./pages/xiaobaGroup/myGroup.vue"),
    meta: {
      title: "我的群",
    },
  },
  {
    path: "/xiaobaGroup/rewardDetails",
    component: () => import("./pages/xiaobaGroup/rewardDetails.vue"),
    meta: {
      title: "奖励明细",
    },
  },
  {
    path: "/xiaobaGroup/specificMerchant",
    component: () => import("./pages/xiaobaGroup/specificMerchant.vue"),
    meta: {
      title: "具体商家",
    },
  },
  {
    path: "/xiaobaGroup/merchantRegisterCode",
    component: () => import("./pages/xiaobaGroup/merchantRegisterCode.vue"),
    meta: {
      title: "商家推广",
    },
  },
  {
    path: "/xiaobaGroup/myAchievement",
    component: () => import("./pages/xiaobaGroup/myAchievement.vue"),
    meta: {
      title: "我的业绩",
    },
  },
  {
    path: "/xiaobaGroup/registerMerchant",
    component: () => import("./pages/xiaobaGroup/registerMerchant.vue"),
    meta: {
      title: "开通商家",
    },
  },

  // 房产项目(解决冲突不要删我房产的东西，求你了！！！！！！)
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/signContract",
    component: () => import("./pages/house/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/signature",
    component: () => import("./pages/house/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/Signed",
    component: () => import("./pages/house/Signed.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/waitSigned",
    component: () => import("./pages/house/waitSigned.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/person/signContract",
    component: () => import("./pages/house/personSign/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/person/signature",
    component: () => import("./pages/house/personSign/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/person/signed",
    component: () => import("./pages/house/personSign/Signed.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/videoTabPage",
    component: () => import("./pages/house/videoTabPage.vue"),
    meta: {
      title: "视频专区",
      keepAlive: true,
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/player",
    component: () => import("./pages/house/player.vue"),
    meta: {
      title: "视频详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！!
    path: "/house/playerShare",
    component: () => import("./pages/house/playerShare.vue"),
    meta: {
      title: "视频详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/houseDetail",
    component: () => import("./pages/house/houseDetail.vue"),
    meta: {
      title: "房源详情",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/newHouseDetail",
    component: () => import("./pages/house/newHouseDetail.vue"),
    meta: {
      title: "楼盘详情",
    },
  },
  {
    path: "/house/subsidies/signContract",
    component: () => import("./pages/house/subsidies/signContract.vue"),
    meta: {
      title: "合同签署",
    },
  },
  {
    // 解决冲突不要删我房产的东西，求你了！！！！！！
    path: "/house/subsidies/signature",
    component: () => import("./pages/house/subsidies/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/house/cms/agreementPage",
    component: () => import("./pages/house/cms/agreementPage.vue"),
    meta: {
      title: "协议",
    },
  },
  {
    path: "/xiaobaGroup/groupCode",
    component: () => import("./pages/xiaobaGroup/groupCode.vue"),
    meta: {
      title: "销巴群主",
    },
  },
  {
    path: "/xiaobaGroup/joinGroup",
    component: () => import("./pages/xiaobaGroup/joinGroup.vue"),
    meta: {
      title: "入群赚取推广奖励",
    },
  },
  {
    path: "/xiaobaGroup/groupRule",
    component: () => import("./pages/xiaobaGroup/groupRule.vue"),
    meta: {
      title: "群政策解读",
    },
  },
  {
    path: "/xiaobaGroup/myGroup",
    component: () => import("./pages/xiaobaGroup/myGroup.vue"),
    meta: {
      title: "我的群",
    },
  },
  {
    path: "/xiaobaGroup/rewardDetails",
    component: () => import("./pages/xiaobaGroup/rewardDetails.vue"),
    meta: {
      title: "奖励明细",
    },
  },
  {
    path: "/xiaobaGroup/specificMerchant",
    component: () => import("./pages/xiaobaGroup/specificMerchant.vue"),
    meta: {
      title: "具体商家",
    },
  },
  {
    path: "/xiaobaGroup/merchantRegisterCode",
    component: () => import("./pages/xiaobaGroup/merchantRegisterCode.vue"),
    meta: {
      title: "商家推广",
    },
  },
  {
    path: "/xiaobaGroup/myAchievement",
    component: () => import("./pages/xiaobaGroup/myAchievement.vue"),
    meta: {
      title: "我的业绩",
    },
  },
  {
    path: "/xiaobaGroup/registerMerchant",
    component: () => import("./pages/xiaobaGroup/registerMerchant.vue"),
    meta: {
      title: "开通商家",
    },
  },
  //中外云仓
  {
    path: "/yuncang/index",
    component: () => import("./pages/yuncang/index.vue"),
    meta: {
      title: "首页",
      keepAlive: true,
    },
  },
  {
    path: "/yuncang/search",
    component: () => import("./pages/yuncang/searchPage.vue"),
    meta: {
      title: "搜索",
      keepAlive: false,
    },
  },
  {
    path: "/yuncang/classify",
    component: () => import("./pages/yuncang/classify.vue"),
    meta: {
      title: "全部分类",
      keepAlive: true,
    },
  },
  {
    path: "/yuncang/explain",
    component: () => import("./pages/yuncang/explain.vue"),
    meta: {
      title: "说明",
    },
  },
  {
    path: "/yuncang/goodsList",
    component: () => import("./pages/yuncang/goodsList.vue"),
    meta: {
      title: "商品列表",
    },
  },
  //三方商城
  {
    path: "/thirdMall/rebateExplain",
    component: () => import("./pages/thirdMall/rebateExplain.vue"),
    meta: {
      title: "返佣规则",
    },
  },
  {
    path: "/thirdMall/savingStrategy",
    component: () => import("./pages/thirdMall/savingStrategy.vue"),
    meta: {
      title: "省钱攻略",
    },
  },
  {
    path: "/thirdMall/downLoad",
    component: () => import("./pages/thirdMall/copyDownload.vue"),
    meta: {
      title: "销巴生活",
    },
  },
  //三方缴费
  {
    path: "/thirdPay/rebateExplain",
    component: () => import("./pages/thirdPay/rebateExplain.vue"),
    meta: {
      title: "如何获取户号",
    },
  },
  //三方外卖
  {
    path: "/takeOut/rebateExplain",
    component: () => import("./pages/takeOut/rebateExplain.vue"),
    meta: {
      title: "规则说明",
    },
  },
  {
    path: "/accountAgent/index",
    component: () => import("./pages/accountAgent/index/index.vue"),
    meta: {
      title: "账号代运营",
    },
  },
  {
    path: "/accountAgent/my",
    component: () => import("./pages/accountAgent/my/index.vue"),
    meta: {
      title: "我的",
    },
  },
  {
    path: "/accountAgent/rule",
    component: () => import("./pages/accountAgent/rule/index.vue"),
    meta: {
      title: "认领手机",
    },
  },
  {
    path: "/accountAgent/confirm",
    component: () => import("./pages/accountAgent/order/confirm.vue"),
    meta: {
      title: "确认订单",
    },
  },
  {
    path: "/accountAgent/result",
    component: () => import("./pages/accountAgent/result/index.vue"),
    meta: {
      title: "结果页",
    },
  },
  {
    path: "/accountAgent/signContract",
    component: () => import("./pages/accountAgent/sign/signContract.vue"),
    meta: {
      title: "三方协议合同",
    },
  },
  {
    path: "/accountAgent/signature",
    component: () => import("./pages/accountAgent/sign/signature.vue"),
    meta: {
      title: "三方协议合同",
    },
  },
  {
    path: "/accountAgent/electroniContract",
    component: () => import("./pages/accountAgent/sign/electroniContract"),
    meta: {
      title: "查看电子合同",
    },
  },
  {
    path: "/accountAgent/address",
    component: () => import("./pages/accountAgent/order/address.vue"),
    meta: {
      title: "选择地址",
    },
  },
  {
    path: "/accountAgent/order",
    component: () => import("./pages/accountAgent/order/index.vue"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/accountAgent/detail",
    component: () => import("./pages/accountAgent/order/detail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/accountAgent/refundDetail",
    component: () => import("./pages/accountAgent/order/refundDetail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/accountAgent/refund",
    component: () => import("./pages/accountAgent/order/refund.vue"),
    meta: {
      title: "申请退还",
    },
  },
  {
    path: "/purchaseSupplier/index",
    component: () => import("./pages/purchaseSupplier/index/index.vue"),
    meta: {
      title: "供应方首页",
    },
  },
  {
    path: "/purchaseSupplier/order",
    component: () => import("./pages/purchaseSupplier/order/index.vue"),
    meta: {
      title: "订单",
    },
  },
  {
    path: "/purchaseSupplier/searchOrder",
    component: () => import("./pages/purchaseSupplier/order/searchOrder.vue"),
    meta: {
      title: "订单",
    },
  },
  {
    path: "/purchaseSupplier/afterOrder",
    component: () => import("./pages/purchaseSupplier/order/afterOrder.vue"),
    meta: {
      title: "待收货(售后)",
    },
  },
  {
    path: "/purchaseSupplier/searchAfterOrder",
    component: () =>
      import("./pages/purchaseSupplier/order/searchAfterOrder.vue"),
    meta: {
      title: "待收货(售后)",
    },
  },
  {
    path: "/purchaseSupplier/detail",
    component: () => import("./pages/purchaseSupplier/order/detail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/purchaseSupplier/afterDetail",
    component: () => import("./pages/purchaseSupplier/order/afterDetail.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/purchaseSupplier/result",
    component: () => import("./pages/purchaseSupplier/order/result.vue"),
    meta: {
      title: "结果页",
    },
  },
  {
    path: "/purchaseSupplier/ship",
    component: () => import("./pages/purchaseSupplier/order/ship.vue"),
    meta: {
      title: "立即发货",
    },
  },
  {
    path: "/purchaseSupplier/logistics",
    component: () => import("./pages/purchaseSupplier/order/logistics.vue"),
    meta: {
      title: "立即发货",
    },
  },
  {
    path: "/purchaseSupplier/logisticsSearch",
    component: () =>
      import("./pages/purchaseSupplier/order/logisticsSearch.vue"),
    meta: {
      title: "立即发货",
    },
  },
  {
    path: "/purchaseSupplier/logisticsDetail",
    component: () =>
      import("./pages/purchaseSupplier/order/logisticsDetail.vue"),
    meta: {
      title: "物流详情",
    },
  },
  {
    path: "/purchaseSupplier/stock",
    component: () => import("./pages/purchaseSupplier/order/stock.vue"),
    meta: {
      title: "库存管理",
    },
  },
  {
    path: "/purchaseSupplier/changeStock",
    component: () => import("./pages/purchaseSupplier/order/changeStock.vue"),
    meta: {
      title: "库存管理",
    },
  },
  {
    path: "/purchaseSupplier/withdraw",
    component: () => import("./pages/purchaseSupplier/withdraw/index.vue"),
    meta: {
      title: "提现管理",
    },
  },
  {
    path: "/purchaseSupplier/settle",
    component: () => import("./pages/purchaseSupplier/withdraw/settle.vue"),
    meta: {
      title: "收支明细",
    },
  },
  {
    path: "/purchaseSupplier/searchSettled",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/searchSettled.vue"),
    meta: {
      title: "搜索收支明细",
    },
  },
  {
    path: "/purchaseSupplier/withdrawRecord",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/withdrawRecord.vue"),
    meta: {
      title: "提现记录",
    },
  },
  {
    path: "/purchaseSupplier/toWithdraw",
    component: () => import("./pages/purchaseSupplier/withdraw/toWithdraw.vue"),
    meta: {
      title: "发起提现",
    },
  },
  {
    path: "/purchaseSupplier/withdrawDetail",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/withdrawDetail.vue"),
    meta: {
      title: "提现详情",
    },
  },
  {
    path: "/purchaseSupplier/invoice",
    component: () => import("./pages/purchaseSupplier/withdraw/invoice.vue"),
    meta: {
      title: "发票账单",
    },
  },
  {
    path: "/purchaseSupplier/invoiceRecord",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/invoiceRecord.vue"),
    meta: {
      title: "开票记录",
    },
  },
  {
    path: "/purchaseSupplier/invoiceDetail",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/invoiceDetail.vue"),
    meta: {
      title: "开票详情",
    },
  },
  {
    path: "/purchaseSupplier/submitInvoice",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/submitInvoice.vue"),
    meta: {
      title: "提交发票信息",
    },
  },
  {
    path: "/purchaseSupplier/account",
    component: () => import("./pages/purchaseSupplier/withdraw/account.vue"),
    meta: {
      title: "对公账户",
    },
  },
  {
    path: "/purchaseSupplier/supply",
    component: () => import("./pages/purchaseSupplier/supply/index.vue"),
    meta: {
      title: "供应方申请",
    },
  },
  {
    path: "/purchaseSupplier/signature",
    component: () => import("./pages/purchaseSupplier/contract/signature.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    path: "/purchaseSupplier/contractResult",
    component: () => import("./pages/purchaseSupplier/contract/result.vue"),
    meta: {
      title: "合同签署结果页",
    },
  },
  {
    path: "/purchaseSupplier/contractDetail",
    component: () =>
      import("./pages/purchaseSupplier/contract/electroniContract.vue"),
    meta: {
      title: "合同详情",
    },
  },
  {
    path: "/purchaseSupplier/pdf",
    component: () => import("./pages/purchaseSupplier/contract/pdf.vue"),
    meta: {
      title: "pdf",
    },
  },
  {
    path: "/purchaseSupplier/bind",
    component: () => import("./pages/purchaseSupplier/withdraw/bind.vue"),
    meta: {
      title: "绑定企业支付宝账户",
    },
  },
  {
    path: "/purchaseSupplier/alipay",
    component: () => import("./pages/purchaseSupplier/withdraw/alipayInfo.vue"),
    meta: {
      title: "查看支付宝账户",
    },
  },
  {
    path: "/purchaseSupplier/changeBind",
    component: () => import("./pages/purchaseSupplier/withdraw/changeBind.vue"),
    meta: {
      title: "修改账户信息",
    },
  },
  {
    path: "/purchaseSupplier/alipayWithdrawDetail",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/alipayWithdrawDetail.vue"),
    meta: {
      title: "提现详情",
    },
  },
  {
    path: "/purchaseSupplier/selectIndentity",
    component: () =>
      import("./pages/purchaseSupplier/supply/selectIndentity.vue"),
    meta: {
      title: "供应方申请",
    },
  },
  {
    path: "/purchaseSupplier/invoiceMsg",
    component: () => import("./pages/purchaseSupplier/withdraw/invoiceMsg.vue"),
    meta: {
      title: "开票资料",
    },
  },
  {
    path: "/purchaseSupplier/bindOrder",
    component: () => import("./pages/purchaseSupplier/withdraw/bindOrder.vue"),
    meta: {
      title: "选择提现订单",
    },
  },
  {
    path: "/purchaseSupplier/bindedOrder",
    component: () =>
      import("./pages/purchaseSupplier/withdraw/bindedOrder.vue"),
    meta: {
      title: "提现订单明细",
    },
  },
  {
    path: "/purchaseSupplier/excel",
    component: () => import("./pages/purchaseSupplier/order/excel.vue"),
    meta: {
      title: "待发货订单记录",
    },
  },
  {
    path: "/purchaseSupplier/accountManage",
    component: () => import("./pages/purchaseSupplier/index/accountManage.vue"),
    meta: {
      title: "账户管理",
    },
  },
  {
    path: "/test",
    component: () => import("./pages/Test.vue"),
    meta: {
      title: "测试",
    },
  },
  // cms
  {
    path: "/cms-article",
    component: () => import("./pages/member/cms/article.vue"),
    meta: {
      title: "资讯",
    },
  },
  {
    path: "/cms-article/detail",
    component: () => import("./pages/member/cms/articleDetail.vue"),
    meta: {
      title: "销巴资讯",
    },
  },
  {
    path: "/cms-agreement/detail",
    component: () => import("./pages/member/cms/agreementDetail.vue"),
    meta: {
      title: "销巴协议",
    },
  },
  {
    path: "/cms-notice",
    component: () => import("./pages/member/cms/notice.vue"),
    meta: {
      title: "公告",
    },
  },
  {
    path: "/cms-notice/detail",
    component: () => import("./pages/member/cms/noticeDetail.vue"),
    meta: {
      title: "销巴公告",
    },
  },
  {
    path: "/equipment/index",
    component: () => import("./pages/equipment/index.vue"),
    meta: {
      title: "设备认领",
    },
  },
  {
    path: "/equipment/rule",
    component: () => import("./pages/equipment/rule.vue"),
    meta: {
      title: "协议内容",
    },
  },
  {
    path: "/equipment/select",
    component: () => import("./pages/equipment/select.vue"),
    meta: {
      title: "选择设备",
    },
  },
  {
    path: "/equipment/my",
    component: () => import("./pages/equipment/my.vue"),
    meta: {
      title: "我的",
    },
  },
  {
    path: "/equipment/order",
    component: () => import("./pages/equipment/order.vue"),
    meta: {
      title: "我的订单",
    },
  },
  // 商学院
  {
    path: "/school/index",
    component: () => import("./pages/school/index.vue"),
    meta: {
      title: "主页",
      keepAlive: true,
    },
  },
  {
    path: "/school/classify",
    component: () => import("./pages/school/classify.vue"),
    meta: {
      title: "分类",
    },
  },
  {
    path: "/school/secondClassify",
    component: () => import("./pages/school/secondClassify.vue"),
    meta: {
      title: "二级分类",
    },
  },
  {
    path: "/school/courseDetailsPicture",
    component: () =>
      import("./pages/school/courseDetails/courseDetailsPicture.vue"),
    meta: {
      title: "图文课程详情",
    },
  },
  {
    path: "/school/courseDetailsVideo",
    component: () =>
      import("./pages/school/courseDetails/courseDetailsVideo.vue"),
    meta: {
      title: "视频课程详情",
    },
  },
  {
    path: "/school/courseDetailsAudio",
    component: () =>
      import("./pages/school/courseDetails/courseDetailsAudio.vue"),
    meta: {
      title: "音频课程详情",
    },
  },
  {
    path: "/school/courseDetailsSpecial",
    component: () =>
      import("./pages/school/courseDetails/courseDetailsSpecial.vue"),
    meta: {
      title: "专栏详情",
    },
  },
  {
    path: "/school/search",
    component: () => import("./pages/school/search.vue"),
    meta: {
      title: "搜索",
    },
  },
  {
    path: "/school/comment",
    component: () => import("./pages/school/comment.vue"),
    meta: {
      title: "评价",
    },
  },
  {
    path: "/school/lecturerDetails",
    component: () => import("./pages/school/lecturerDetails.vue"),
    meta: {
      title: "讲师详情",
    },
  },
  {
    path: "/school/collect",
    component: () => import("./pages/school/collect.vue"),
    meta: {
      title: "收藏",
    },
  },
  {
    path: "/school/attention",
    component: () => import("./pages/school/attention.vue"),
    meta: {
      title: "关注",
    },
  },
  {
    path: "/school/courseList",
    component: () => import("./pages/school/courseList.vue"),
    meta: {
      title: "课程列表",
    },
  },
  {
    path: "/school/lecturerList",
    component: () => import("./pages/school/lecturerList.vue"),
    meta: {
      title: "讲师列表",
    },
  },
  {
    path: "/school/previewHome",
    component: () => import("./pages/school/previewHome.vue"),
    meta: {
      title: "首页预览",
    },
  },
  {
    path: "/school/filePreview",
    component: () => import("./pages/school/filePreview.vue"),
    meta: {
      title: "课件预览",
    },
  },
  {
    path: "/school/searchResult",
    component: () => import("./pages/school/searchResult.vue"),
    meta: {
      title: "搜索结果",
      keepAlive: true,
    },
  },
  {
    path: "/school/firstClassify",
    component: () => import("./pages/school/firstClassify.vue"),
    meta: {
      title: "一级分类",
    },
  },
  {
    path: "/school/shareRegister",
    component: () => import("./pages/school/shareRegister.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/school/homeSet",
    component: () => import("./pages/school/homeSet.vue"),
    meta: {
      title: "销巴商学院",
    },
  },
  {
    path: "/school/tripartiteLink",
    component: () => import("./pages/school/tripartiteLink.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/school/load",
    component: () => import("./pages/school/load.vue"),
    meta: {
      title: "销巴生活",
    },
  },
  // 商学院end
  {
    path: "/doubleEleven/playingMethod",
    component: () => import("./pages/doubleEleven/playingMethod.vue"),
    meta: {
      title: "淘宝双十一预售商品玩法",
    },
  },
  {
    path: "/doubleEleven/calendarDiscounts",
    component: () => import("./pages/doubleEleven/calendarDiscounts.vue"),
    meta: {
      title: "活动日历锁定到手优惠",
    },
  },
  {
    path: "/thirdPay/commonProblems",
    component: () => import("./pages/thirdPay/commonProblems.vue"),
    meta: {
      title: "常见问题",
    },
  },
  // 装饰start
  {
    path: "/decoration/index",
    component: () => import("./pages/decoration/index.vue"),
    meta: {
      title: "装饰入口",
    },
  },
  {
    path: "/decoration/deputy/index",
    component: () => import("./pages/decoration/deputy/index.vue"),
    meta: {
      title: "装饰代理人入口",
    },
  },
  {
    path: "/decoration/deputy/home",
    component: () => import("./pages/decoration/deputy/home.vue"),
    meta: {
      title: "申请代理人入口",
    },
  },
  {
    path: "/decoration/deputy/applyFor",
    component: () => import("./pages/decoration/deputy/applyFor.vue"),
    meta: {
      title: "申请个人代理人",
    },
  },
  {
    path: "/decoration/deputy/enterpriseApplyFor",
    component: () => import("./pages/decoration/deputy/enterpriseApplyFor.vue"),
    meta: {
      title: "申请企业代理人",
      keepAlive: true,
    },
  },
  {
    path: "/decoration/deputy/uploadDocuments",
    component: () => import("./pages/decoration/deputy/uploadDocuments.vue"),
    meta: {
      title: "上传缴费凭证",
    },
  },
  {
    path: "/decoration/deputy/details",
    component: () => import("./pages/decoration/deputy/details.vue"),
    meta: {
      title: "代理人详情",
    },
  },
  {
    path: "/decoration/deputy/more",
    component: () => import("./pages/decoration/deputy/more.vue"),
    meta: {
      title: "更多",
    },
  },
  {
    path: "/decoration/deputy/payFees",
    component: () => import("./pages/decoration/deputy/payFees.vue"),
    meta: {
      title: "交易明细",
    },
  },
  {
    path: "/decoration/deputy/payFeesDetails",
    component: () => import("./pages/decoration/deputy/payFeesDetails.vue"),
    meta: {
      title: "交易详情",
    },
  },
  {
    path: "/decoration/deputy/centCommissionDetails",
    component: () =>
      import("./pages/decoration/deputy/centCommissionDetails.vue"),
    meta: {
      title: "结算详情",
    },
  },
  {
    path: "/decoration/deputy/contractList",
    component: () => import("./pages/decoration/deputy/contractList.vue"),
    meta: {
      title: "合同列表",
    },
  },
  {
    path: "/decoration/deputy/seeContract",
    component: () => import("./pages/decoration/deputy/seeContract.vue"),
    meta: {
      title: "查看合同",
    },
  },
  {
    path: "/decoration/deputy/signContract",
    component: () => import("./pages/decoration/deputy/signContract.vue"),
    meta: {
      title: "签署合同",
    },
  },
  {
    path: "/decoration/deputy/signature",
    component: () => import("./pages/decoration/deputy/signature.vue"),
    meta: {
      title: "签名",
    },
  },
  {
    path: "/decoration/deputy/payResult",
    component: () => import("./pages/decoration/deputy/payResult.vue"),
    meta: {
      title: "支付结果",
    },
  },
  {
    path: "/decoration/cityPartner/index",
    component: () => import("./pages/decoration/cityPartner/index.vue"),
    meta: {
      title: "装饰合伙人入口",
    },
  },
  {
    path: "/decoration/cityPartner/citySelect",
    component: () => import("./pages/decoration/cityPartner/citySelect.vue"),
    meta: {
      title: "装饰合伙人城市选择",
    },
  },
  {
    path: "/decoration/cityPartner/details",
    component: () => import("./pages/decoration/cityPartner/details.vue"),
    meta: {
      title: "装饰合伙人详情",
      keepAlive: true,
    },
  },
  {
    path: "/decoration/cityPartner/more",
    component: () => import("./pages/decoration/cityPartner/more.vue"),
    meta: {
      title: "更多",
    },
  },
  {
    path: "/decoration/order/orderList",
    component: () => import("./pages/decoration/order/orderList.vue"),
    meta: {
      title: "装饰订单",
    },
  },
  {
    path: "/decoration/order/orderDetails",
    component: () => import("./pages/decoration/order/orderDetails.vue"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/decoration/order/subsidyList",
    component: () => import("./pages/decoration/order/subsidyList.vue"),
    meta: {
      title: "补贴记录",
    },
  },
  {
    path: "/decoration/order/subsidyDetails",
    component: () => import("./pages/decoration/order/subsidyDetails.vue"),
    meta: {
      title: "补贴详情",
    },
  },
  {
    path: "/decoration/embody/embody",
    component: () => import("./pages/decoration/embody/embody.vue"),
    meta: {
      title: "体现",
    },
  },
  {
    path: "/decoration/embody/applyForEmbody",
    component: () => import("./pages/decoration/embody/applyForEmbody.vue"),
    meta: {
      title: "申请提现",
      keepAlive: true,
    },
  },
  {
    path: "/decoration/embody/embodyDetails",
    component: () => import("./pages/decoration/embody/embodyDetails.vue"),
    meta: {
      title: "体现详情",
    },
  },
  {
    path: "/decoration/embody/embodySuccess",
    component: () => import("./pages/decoration/embody/embodySuccess.vue"),
    meta: {
      title: "提现结果",
    },
  },
  {
    path: "/decoration/embody/invoice",
    component: () => import("./pages/decoration/embody/invoice.vue"),
    meta: {
      title: "发票信息",
    },
  },
  {
    path: "/decoration/embody/earningsList",
    component: () => import("./pages/decoration/embody/earningsList.vue"),
    meta: {
      title: "收益明细",
    },
  },
  {
    path: "/decoration/embody/earningsDetails",
    component: () => import("./pages/decoration/embody/earningsDetails.vue"),
    meta: {
      title: "收益明细详情",
    },
  },
  {
    path: "/decoration/order/moreDetails",
    component: () => import("./pages/decoration/order/moreDetails.vue"),
    meta: {
      title: "更多信息",
    },
  },
  {
    path: "/decoration/order/seeContract",
    component: () => import("./pages/decoration/order/seeContract.vue"),
    meta: {
      title: "查看订单合同",
    },
  },
  {
    path: "/decoration/order/signContract",
    component: () => import("./pages/decoration/order/signContract.vue"),
    meta: {
      title: "签署订单合同",
    },
  },
  {
    path: "/decoration/order/pdfView",
    component: () => import("./pages/decoration/order/pdfView.vue"),
    meta: {
      title: "查看PDF",
    },
  },
  {
    path: "/tickets/bookingDetails",
    component: () => import("./pages/tickets/bookingDetails.vue"),
    meta: {
      title: "预定详情",
    },
  },
  {
    path: "/tickets/bookingInstructions",
    component: () => import("./pages/tickets/bookingInstructions.vue"),
    meta: {
      title: "预定须知",
    },
  },
  {
    path: "/tickets/binglePageDescription",
    component: () => import("./pages/tickets/binglePageDescription.vue"),
    meta: {
      title: "下单页-说明",
    },
  },
  {
    path: "/tickets/descriptionPopup",
    component: () => import("./pages/tickets/descriptionPopup.vue"),
    meta: {
      title: "购票须知弹窗",
    },
  },
  {
    path: "/tickets/orderDescription",
    component: () => import("./pages/tickets/orderDescription.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/addChangeAlert",
    component: () => import("./pages/tickets/addChangeAlert.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/ticketSharing",
    component: () => import("./pages/tickets/ticketSharing.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/ticketCollectionInformation",
    component: () => import("./pages/tickets/ticketCollectionInformation.vue"),
    meta: {
      title: "更多取票信息",
    },
  },
  // 装饰end
  {
    path: "/tickets/bookingDetails",
    component: () => import("./pages/tickets/bookingDetails.vue"),
    meta: {
      title: "预定详情",
    },
  },
  {
    path: "/tickets/bookingInstructions",
    component: () => import("./pages/tickets/bookingInstructions.vue"),
    meta: {
      title: "预定须知",
    },
  },
  {
    path: "/tickets/binglePageDescription",
    component: () => import("./pages/tickets/binglePageDescription.vue"),
    meta: {
      title: "下单页-说明",
    },
  },
  {
    path: "/tickets/descriptionPopup",
    component: () => import("./pages/tickets/descriptionPopup.vue"),
    meta: {
      title: "购票须知弹窗",
    },
  },
  {
    path: "/tickets/orderDescription",
    component: () => import("./pages/tickets/orderDescription.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/addChangeAlert",
    component: () => import("./pages/tickets/addChangeAlert.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/ticketSharing",
    component: () => import("./pages/tickets/ticketSharing.vue"),
    meta: {
      title: "订单-说明",
    },
  },
  {
    path: "/tickets/ticketCollectionInformation",
    component: () => import("./pages/tickets/ticketCollectionInformation.vue"),
    meta: {
      title: "更多取票信息",
    },
  },
  {
    path: "/fansShow",
    component: () => import("./pages/member/fansShow.vue"),
    meta: {
      title: "粉丝说明",
    },
  },
  //本地生活
  {
    path: "/localLife/activityList",
    component: () => import("./pages/localLife/activityList.vue"),
    meta: {
      title: "活动列表",
    },
  },
  {
    path: "/localLife/localLifeAllOrders",
    component: () => import("./pages/localLife/localLifeAllOrders.vue"),
    meta: {
      title: "全部订单",
    },
  },
  ...sharehotel_router,
  ...group_buy,
  ...third_route,
  ...group_rob,
  ...new_oil_card,
  ...lifecircle,
  ...car_rent,
  ...lucky,
];

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path == "/talentCode") {
    window.location.replace(
      process.env.VUE_APP_TALENT + window.location.search
    );
    return false;
  }
  if (to.path == "/talentGoods") {
    window.location.replace(
      process.env.VUE_APP_TALENT +
        "/talentUpgrade/talentgoods" +
        window.location.search
    );
    return false;
  }
  let title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
  if (!["酒店详情"].includes(to.meta.title)) {
    window.scrollTo(0, 0);
  }
});

export default router;
